import { render, staticRenderFns } from "./customerServiceDepartment.vue?vue&type=template&id=635ea5f4&scoped=true"
import script from "./customerServiceDepartment.vue?vue&type=script&lang=js"
export * from "./customerServiceDepartment.vue?vue&type=script&lang=js"
import style0 from "./customerServiceDepartment.vue?vue&type=style&index=0&id=635ea5f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635ea5f4",
  null
  
)

export default component.exports